<template>
  <v-container fluid class="px-0 pt-0">
    <v-row>
      <v-col class="pb-0">
        <h3 class="mt-6 mb-2 text-black">
          {{ $t('warehouse.forms.createWarehouseForm.messages.amenitiesAvailableAtTheWarehouse') }}
        </h3>
      </v-col>
    </v-row>

    <v-row class="mt-0 pt-0">
      <v-col cols="12" class="d-flex justify-left flex-wrap">
        <v-checkbox
          :key="item"
          v-for="item in amenitiesEnum"
          :label="item"
          hide-details
          color="primary"
          :model-value="fields.amenities?.includes(item)"
          @click="() => toggleItem(item, 'amenities')"
          class="mr-4 mt-0"></v-checkbox>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col class="py-0">
        <h3 class="mt-6 mb-2 text-black">
          {{ $t('warehouse.forms.createWarehouseForm.messages.ppeAndOtherRequirements') }}
        </h3>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12" class="d-flex justify-left flex-wrap">
        <v-checkbox
          :key="item"
          v-for="item in ppeRequirementsEnum"
          :label="item"
          color="primary"
          :model-value="fields.ppeRequirements?.includes(item)"
          hide-details
          @click="() => toggleItem(item, 'ppeRequirements')"
          class="mr-4 mt-0"></v-checkbox>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { camelCase } from 'lodash';

export default {
  props: {
    fields: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    amenitiesEnum() {
      return Object.values(this.novaCore.AmenitiesEnum).map(amenity =>
        this.$t(`global.warehouseAmenities.${camelCase(amenity)}`)
      );
    },
    ppeRequirementsEnum() {
      return Object.values(this.novaCore.PPERequirementsEnum).map(requirement =>
        this.$t(`global.warehousePPERequirements.${camelCase(requirement)}`)
      );
    }
  },
  mounted() {
    if (!this.fields.amenities) {
      this.fields.amenities = [];
    }
    if (!this.fields.ppeRequirements) {
      this.fields.ppeRequirements = [];
    }
  },
  methods: {
    toggleItem(item, category) {
      const existingItemIndex = this.fields[category].findIndex(
        existingItem => existingItem === item
      );

      const categoryField = [...this.fields[category]];

      if (existingItemIndex < 0) {
        categoryField.push(item);
      } else {
        categoryField.splice(existingItemIndex, 1);
      }

      this.fields[category] = categoryField;
    }
  }
};
</script>
